import { Navigate } from "react-router-dom";
import { checkIfAuthenticated } from "../utils/utils";
import { useEffect, useState } from "react";

const RequireAuth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    checkIfAuthenticated()
  );

  useEffect(() => {
    const validateAuth = () => {
      setIsAuthenticated(checkIfAuthenticated());
    };

    validateAuth();

    const interval = setInterval(() => {
      validateAuth();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default RequireAuth;
